import { render, staticRenderFns } from "./MenuVisualizaciones.vue?vue&type=template&id=0a4c27dc&scoped=true&"
import script from "./MenuVisualizaciones.vue?vue&type=script&lang=js&"
export * from "./MenuVisualizaciones.vue?vue&type=script&lang=js&"
import style0 from "./MenuVisualizaciones.vue?vue&type=style&index=0&id=0a4c27dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c27dc",
  null
  
)

export default component.exports